import { Component, ElementRef, HostListener, Input, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { DropdownMenuComponent } from '../dropdown-menu/dropdown-menu.component';
import { CompanyLine, ProductLine } from 'src/app/model/product/product.model';
import { PRODUCT_LINES } from 'src/app/data/product/product.data';
import { Router } from '@angular/router';
import { URLS } from '../../data/navigation/navigation.data';


@Component({
  selector: 'app-company-dropdown',
  templateUrl: './company-dropdown.component.html',
  styleUrls: ['./company-dropdown.component.scss']
})
export class CompanyDropdownComponent {
  @Input() companies: any[] = [];
  @Input() dropdownParent: HTMLElement = null;

  @ViewChild('dropdownMenuProducts') dropdownMenuProducts: DropdownMenuComponent;
  @ViewChildren('dropdownMenus') dropdownMenus: QueryList<DropdownMenuComponent>;

  @ViewChild('dropdownMenuParent') dropdownMenuParent: ElementRef;


  PRODUCT_LINES: ProductLine[] = PRODUCT_LINES;
  URLS = URLS;

  isDropdownOpen = false;

  constructor(
    private router: Router) {
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  openDropdown(): void {
    this.isDropdownOpen = true;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  toggleProductDropdown(index: number): void {
    const dropdown = this.dropdownMenus.toArray()[index];
    if (dropdown) {
      dropdown.toggleDropdown();
    }
  }

  closeProductDropdown(index: number): void {
    const dropdown = this.dropdownMenus.toArray()[index];
    if (dropdown) {
      dropdown.closeDropdown();
    }
  }

  routeToCompany(company: CompanyLine) {
    // Note: When new key is added please change this or depend on static text
    switch (company.key) {
      case 1:
        this.closeDropdown();
        this.router.navigate([URLS.alcadeEngineers]);
        break;
      case 2:
        this.closeDropdown();
        this.router.navigate([URLS.srEngineers]);
        break;
      case 3:
        this.closeDropdown();
        this.router.navigate([URLS.warehouse]);
        break;
    
      default:
        console.warn('Unknown company key:', company.key);
        break;
    }    
  }

  // Optional: detect outside clicks if needed
  @HostListener('document:click', ['$event.target'])
  public onClickOutside(target: HTMLElement) {
    if (!this.dropdownParent?.contains(target)) {
      this.closeDropdown();
    }
  }
}
